"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface ReviewOfEstimatesForManagementBiasSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Review of Estimates for Management Bias";

export default function ReviewOfEstimatesForManagementBiasSubstantive({ onBack, setActiveSection }: ReviewOfEstimatesForManagementBiasSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
